import BotonInstructivo from "./BotonInstructivo";
import BotonMapaProceso from "./BotonMapaProceso";
import { useState } from "react";
import { subirDatos } from "./syncSupabase";

const Q = {
  azul:"#1C3FAA", azulVivo:"#2A7FFF", azulMedio:"#6B6FD6",
  grisClaro:"#E8E9F6", grisPalido:"#F4F6FB", grisOscuro:"#2B2F36",
  grisPlata:"#8E93A1", blanco:"#FFFFFF",
};

const severidades = {
  baja:    {label:"🟢 Baja",    color:"#22c55e"},
  media:   {label:"🟡 Media",   color:"#f59e0b"},
  alta:    {label:"🔴 Alta",    color:"#e63946"},
  critica: {label:"🚨 Crítica", color:"#7c3aed"},
};

const estadosIncidente = {
  abierto:    {label:"🔓 Abierto",    color:"#e63946"},
  en_proceso: {label:"🔵 En proceso", color:"#2A7FFF"},
  resuelto:   {label:"✅ Resuelto",   color:"#22c55e"},
  cerrado:    {label:"📁 Cerrado",    color:"#808085"},
};

const tiposIncidente = [
  "Acceso no autorizado","Phishing / Email malicioso","Pérdida de dispositivo",
  "Contraseña comprometida","Ataque ransomware","Fuga de datos","Caída del sistema",
  "Malware detectado","Acceso de exempleado","Intento de intrusión","Otro",
];

const CHECKLIST_CONTROLES_DEFAULT = [
  {id:"bk",  label:"Backup activo y verificado",               critico:true,  frecuencia:"Mensual"},
  {id:"pw",  label:"Contraseñas actualizadas (>90 días)",       critico:true,  frecuencia:"Trimestral"},
  {id:"usr", label:"Usuarios inactivos eliminados",             critico:true,  frecuencia:"Mensual"},
  {id:"av",  label:"Antivirus/EDR activo y actualizado",        critico:true,  frecuencia:"Mensual"},
  {id:"ex",  label:"Accesos de exempleados revocados",          critico:true,  frecuencia:"Inmediato"},
  {id:"sw",  label:"Software del sistema actualizado",          critico:false, frecuencia:"Mensual"},
  {id:"fw",  label:"Firewall activo y reglas revisadas",        critico:false, frecuencia:"Trimestral"},
  {id:"mfa", label:"MFA habilitado en cuentas críticas",        critico:false, frecuencia:"Trimestral"},
  {id:"log", label:"Logs de acceso revisados",                  critico:false, frecuencia:"Mensual"},
  {id:"red", label:"Red WiFi corporativa segura (WPA3)",        critico:false, frecuencia:"Anual"},
  {id:"nub", label:"Permisos de nube (Vercel/Supabase) revisados",critico:false,frecuencia:"Trimestral"},
  {id:"pol", label:"Política de contraseñas comunicada al equipo",critico:false,frecuencia:"Anual"},
];

const PLANES_RESPUESTA = [
  {
    id:"plan_perdida",
    titulo:"Pérdida de dispositivo",
    icono:"📱",
    color:"#f59e0b",
    pasos:[
      "Reportar inmediatamente al Administrador del sistema.",
      "Revocar acceso del dispositivo a ALQOS™ y cuentas corporativas (Google, email).",
      "Cambiar contraseñas de todas las cuentas que estaban en el dispositivo.",
      "Verificar si el dispositivo tenía datos sensibles de clientes o certificaciones.",
      "Registrar el incidente en ALQOS™ con severidad Alta.",
      "Si hay datos de clientes comprometidos, notificar según Ley 25.326 PDPA.",
    ]
  },
  {
    id:"plan_phishing",
    titulo:"Email de phishing recibido",
    icono:"📧",
    color:"#3b82f6",
    pasos:[
      "No hacer clic en ningún enlace ni descargar adjuntos.",
      "Reportar el email al Administrador y marcar como phishing en el cliente de correo.",
      "Si ya se hizo clic: cambiar contraseñas inmediatamente y escanear el equipo.",
      "Registrar el incidente en ALQOS™ indicando si se abrió algún enlace.",
      "Verificar si otros usuarios recibieron el mismo email.",
      "Agregar el dominio remitente a la lista negra del servidor de correo.",
    ]
  },
  {
    id:"plan_ransomware",
    titulo:"Ataque ransomware",
    icono:"🔐",
    color:"#7c3aed",
    pasos:[
      "INMEDIATO: Desconectar el equipo afectado de la red (WiFi y cable).",
      "No apagar el equipo — preservar evidencia en memoria.",
      "Contactar soporte técnico especializado de inmediato.",
      "No pagar el rescate — no garantiza recuperación de datos.",
      "Restaurar desde el último backup verificado.",
      "Registrar incidente en ALQOS™ como Crítico.",
      "Notificar a clientes si sus datos pueden estar comprometidos.",
      "Reportar a la DIRECCIÓN y evaluar impacto en certificaciones ISO.",
    ]
  },
  {
    id:"plan_exempleado",
    titulo:"Acceso de exempleado",
    icono:"🚪",
    color:"#e63946",
    pasos:[
      "Revocar acceso en ALQOS™ desde Gestión de Usuarios → Desactivar usuario.",
      "Cambiar contraseñas compartidas que el empleado pudiera conocer.",
      "Revocar acceso a: email corporativo, Google Drive, GitHub, Vercel, Supabase.",
      "Revisar logs de actividad reciente del usuario en el sistema.",
      "Registrar incidente en ALQOS™.",
      "Si hay indicios de uso malicioso, consultar asesor legal.",
    ]
  },
];

function generarCodIncidente(lista) { return `INC-${new Date().getFullYear()}-${String(lista.length+1).padStart(4,"0")}`; }
function fechaHoy() { return new Date().toISOString().slice(0,10); }

export default function Ciberseguridad({ onVolver, oscuro, usuario }) {
  const [tab, setTab] = useState("incidentes");

  const [incidentes, setIncidentes] = useState(() => {
    try { return JSON.parse(localStorage.getItem('alqos_ciberseg_inc')||'[]'); } catch { return []; }
  });
  const [activos, setActivos] = useState(() => {
    try { return JSON.parse(localStorage.getItem('alqos_ciberseg_activos')||'[]'); } catch { return []; }
  });
  const [controles, setControles] = useState(() => {
    try { return JSON.parse(localStorage.getItem('alqos_ciberseg_ctrl')||'null') || CHECKLIST_CONTROLES_DEFAULT; } catch { return CHECKLIST_CONTROLES_DEFAULT; }
  });

  const [vista, setVista]       = useState("listado");
  const [form, setForm]         = useState({ severidad:"media", tipo:tiposIncidente[0], fecha:fechaHoy(), estado:"abierto" });
  const [formActivo, setFormActivo] = useState({});
  const [detalle, setDetalle]   = useState(null);
  const [vistaPlanes, setVistaPlanes] = useState(false);
  const [planActivo, setPlanActivo]   = useState(null);
  

  const esAdmin = usuario?.rol === "Administrador";

  const bg      = oscuro ? "#09184D" : Q.grisPalido;
  const cardBg  = oscuro ? "#0d2160" : Q.blanco;
  const texto   = oscuro ? "#EDF2FA" : Q.grisOscuro;
  const borde   = oscuro ? "#1e3a8a" : Q.grisClaro;
  const navBg   = oscuro ? "#060f30" : Q.azul;
  const subtexto= oscuro ? "#9aabd4" : Q.grisPlata;

  const inp = {width:"100%",padding:"9px 12px",borderRadius:"10px",border:`1.5px solid ${borde}`,fontSize:"13px",boxSizing:"border-box",marginTop:"4px",background:cardBg,color:texto,fontFamily:"sans-serif",outline:"none"};
  const lbl = {fontSize:"11px",color:subtexto,fontWeight:"700",display:"block",marginTop:"12px",letterSpacing:".05em",textTransform:"uppercase"};
  const card = {background:cardBg,borderRadius:"14px",padding:"1.5rem",border:`1px solid ${borde}`,marginBottom:"14px"};

  const guardarIncidente = () => {
    if (!form.descripcion?.trim()) { alert("⚠️ La descripción es obligatoria."); return; }
    const nuevo = {...form, id:Date.now(), codigo:generarCodIncidente(incidentes), fechaCreacion:new Date().toISOString(), creadoPor:usuario?.nombre||"Sistema", rolCreador:usuario?.rol||""};
    const nuevos = [...incidentes, nuevo];
    setIncidentes(nuevos);
    localStorage.setItem('alqos_ciberseg_inc', JSON.stringify(nuevos));
    subirDatos('alqos_ciberseg_inc');
    setForm({severidad:"media",tipo:tiposIncidente[0],fecha:fechaHoy(),estado:"abierto"});
    setVista("listado");
  };

  const guardarActivo = () => {
    if (!formActivo.nombre?.trim()) { alert("⚠️ El nombre del activo es obligatorio."); return; }
    const nuevo = {...formActivo, id:Date.now(), fechaCreacion:new Date().toISOString(), creadoPor:usuario?.nombre};
    const nuevos = [...activos, nuevo];
    setActivos(nuevos);
    localStorage.setItem('alqos_ciberseg_activos', JSON.stringify(nuevos));
    subirDatos('alqos_ciberseg_activos');
    setFormActivo({});
    setVista("listado");
  };

  const cambiarEstadoInc = (id, nuevoEstado) => {
    const act = incidentes.map(i=>i.id===id?{...i,estado:nuevoEstado}:i);
    setIncidentes(act);
    localStorage.setItem('alqos_ciberseg_inc', JSON.stringify(act));
    subirDatos('alqos_ciberseg_inc');
    if (detalle?.id===id) setDetalle(prev=>({...prev,estado:nuevoEstado}));
  };

  const completarControl = (id) => {
    const act = controles.map(c=>c.id===id?{...c,ultimaRevision:new Date().toISOString(),revisadoPor:usuario?.nombre,completado:true}:c);
    setControles(act);
    localStorage.setItem('alqos_ciberseg_ctrl', JSON.stringify(act));
    subirDatos('alqos_ciberseg_ctrl');
  };

  const resumen = {
    incidentesAbiertos:  incidentes.filter(i=>i.estado==="abierto"||i.estado==="en_proceso").length,
    incidentesCriticos:  incidentes.filter(i=>i.severidad==="critica"||i.severidad==="alta").length,
    totalActivos:        activos.length,
    controlesOK:         controles.filter(c=>c.completado).length,
    controlesTotal:      controles.length,
    controlesCriticosPendientes: controles.filter(c=>c.critico&&!c.completado).length,
  };

  const Header = ({titulo,onBack,extra}) => (
    <div style={{background:navBg,padding:"1rem 1.5rem",display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:100,marginBottom:"1.5rem",boxShadow:`0 2px 12px ${Q.azul}40`}}>
      <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
        <button onClick={onBack} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",padding:"6px 14px",borderRadius:"10px",cursor:"pointer",fontSize:"13px"}}>← Volver</button>
        <span style={{color:"white",fontWeight:"700",fontSize:"16px"}}>{titulo}</span>
      </div>
      {extra}
    </div>
  );

  // ── PLAN DE RESPUESTA DETALLE ──
  if (planActivo) return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif"}}>
      <Header titulo={`Plan: ${planActivo.titulo}`} onBack={() => setPlanActivo(null)}/>
      <div style={{padding:"0 2rem 2rem",maxWidth:"700px",margin:"0 auto"}}>
        <div style={{background: oscuro?"#0a1f5c":`${planActivo.color}12`,borderRadius:"16px",padding:"1.5rem",border:`2px solid ${planActivo.color}40`,marginBottom:"14px"}}>
          <div style={{display:"flex",alignItems:"center",gap:"12px",marginBottom:"16px"}}>
            <span style={{fontSize:"32px"}}>{planActivo.icono}</span>
            <div>
              <h2 style={{fontSize:"18px",fontWeight:"800",color:planActivo.color,margin:0}}>{planActivo.titulo}</h2>
              <p style={{fontSize:"12px",color:subtexto,margin:0}}>Plan de respuesta a incidentes · ALQOS™ by QORVEX</p>
            </div>
          </div>
          {planActivo.pasos.map((paso,i)=>(
            <div key={i} style={{display:"flex",gap:"12px",padding:"10px 0",borderBottom:`0.5px solid ${borde}`}}>
              <div style={{width:"28px",height:"28px",borderRadius:"50%",background:planActivo.color,color:"white",fontWeight:"800",fontSize:"12px",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                {i+1}
              </div>
              <p style={{fontSize:"13px",color:texto,lineHeight:"1.6",margin:0,paddingTop:"4px"}}>{paso}</p>
            </div>
          ))}
        </div>
        <div style={{...card,background: oscuro?"#0a1f3c":"#eff6ff",border:`1px solid ${Q.azulVivo}30`}}>
          <p style={{fontSize:"13px",color:subtexto,margin:0}}>
            💡 Una vez resuelto el incidente, recordá registrarlo en el módulo de Incidentes con toda la evidencia de resolución.
          </p>
        </div>
      </div>
    </div>
  );

  // ── DETALLE INCIDENTE ──
  if (vista==="detalle" && detalle) return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif"}}>
      <Header titulo={detalle.codigo} onBack={() => {setDetalle(null); setVista("listado");}}/>
      <div style={{padding:"0 2rem 2rem",maxWidth:"700px",margin:"0 auto"}}>
        <div style={{...card,background: oscuro?"#0a1f5c":`${severidades[detalle.severidad]?.color}12`,border:`1.5px solid ${severidades[detalle.severidad]?.color}40`}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:"12px"}}>
            <div>
              <span style={{fontSize:"11px",fontWeight:"800",color:severidades[detalle.severidad]?.color,background:`${severidades[detalle.severidad]?.color}20`,padding:"2px 10px",borderRadius:"8px",letterSpacing:".1em"}}>{severidades[detalle.severidad]?.label}</span>
              <h3 style={{fontSize:"15px",fontWeight:"700",color:texto,margin:"8px 0 0"}}>{detalle.tipo}</h3>
            </div>
            <span style={{fontSize:"11px",color:subtexto}}>{detalle.fecha}</span>
          </div>
          {[["Código",detalle.codigo],["Descripción",detalle.descripcion],["Sistema afectado",detalle.sistemaAfectado],["Impacto estimado",detalle.impacto],["Responsable",detalle.responsable],["Creado por",`${detalle.creadoPor} — ${detalle.rolCreador}`]].map(([k,v])=>v&&(
            <div key={k} style={{display:"flex",gap:"12px",fontSize:"13px",padding:"5px 0",borderBottom:`0.5px solid ${borde}`}}>
              <span style={{color:subtexto,minWidth:"120px",flexShrink:0}}>{k}</span>
              <span style={{color:texto,fontWeight:"500",lineHeight:"1.5"}}>{v}</span>
            </div>
          ))}
        </div>

        <div style={card}>
          <h3 style={{fontSize:"13px",fontWeight:"700",color:Q.azul,marginBottom:"12px",textTransform:"uppercase",letterSpacing:".05em"}}>Estado del incidente</h3>
          <div style={{display:"flex",gap:"6px",flexWrap:"wrap"}}>
            {Object.entries(estadosIncidente).map(([val,{label,color}])=>(
              <button key={val} onClick={() => esAdmin&&cambiarEstadoInc(detalle.id,val)}
                style={{padding:"7px 12px",borderRadius:"10px",fontSize:"11px",cursor:esAdmin?"pointer":"default",fontWeight:"600",border:detalle.estado===val?`2px solid ${color}`:`1px solid ${borde}`,background:detalle.estado===val?`${color}22`:cardBg,color:detalle.estado===val?color:subtexto}}>
                {label}
              </button>
            ))}
          </div>
        </div>

        {detalle.accionesTomadas && (
          <div style={card}>
            <h3 style={{fontSize:"13px",fontWeight:"700",color:Q.azul,marginBottom:"8px",textTransform:"uppercase",letterSpacing:".05em"}}>Acciones tomadas</h3>
            <p style={{fontSize:"13px",color:texto,lineHeight:"1.6",margin:0}}>{detalle.accionesTomadas}</p>
          </div>
        )}

        <div style={{...card,background: oscuro?"#0a1f3c":"#eff6ff",border:`1px solid ${Q.azulVivo}30`}}>
          <h3 style={{fontSize:"13px",fontWeight:"700",color:Q.azulVivo,marginBottom:"10px",textTransform:"uppercase",letterSpacing:".05em"}}>Plans de respuesta relacionados</h3>
          <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
            {PLANES_RESPUESTA.map(p=>(
              <button key={p.id} onClick={() => setPlanActivo(p)}
                style={{padding:"6px 12px",background:`${p.color}12`,border:`1px solid ${p.color}30`,borderRadius:"10px",cursor:"pointer",fontSize:"12px",color:p.color,fontWeight:"600"}}>
                {p.icono} {p.titulo}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );

  // ── NUEVO INCIDENTE ──
  if (vista==="nuevo_incidente") return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif"}}>
      <Header titulo="🚨 Nuevo Incidente de Seguridad" onBack={() => setVista("listado")}/>
      <div style={{padding:"0 2rem 2rem",maxWidth:"700px",margin:"0 auto"}}>
        <div style={{background:"#fff5f5",border:"1.5px solid #e63946",borderRadius:"12px",padding:"12px 16px",marginBottom:"14px"}}>
          <p style={{fontSize:"13px",fontWeight:"700",color:"#dc2626",margin:"0 0 4px"}}>⚠️ Protocolo de incidentes</p>
          <p style={{fontSize:"12px",color:"#dc2626",margin:0}}>Registrá toda la información disponible. Si el incidente es CRÍTICO, notificá a la Dirección de inmediato y consultá los planes de respuesta.</p>
        </div>

        <div style={card}>
          <span style={lbl}>Tipo de incidente</span>
          <select onChange={e=>setForm(f=>({...f,tipo:e.target.value}))} style={inp}>
            {tiposIncidente.map(t=><option key={t} value={t}>{t}</option>)}
          </select>

          <span style={lbl}>Severidad</span>
          <div style={{display:"flex",gap:"8px",marginTop:"6px",flexWrap:"wrap"}}>
            {Object.entries(severidades).map(([val,{label,color}])=>(
              <button key={val} onClick={() => setForm(f=>({...f,severidad:val}))}
                style={{padding:"7px 12px",borderRadius:"10px",fontSize:"12px",cursor:"pointer",fontWeight:"600",border:form.severidad===val?`2px solid ${color}`:`1px solid ${borde}`,background:form.severidad===val?`${color}22`:cardBg,color:form.severidad===val?color:texto}}>
                {label}
              </button>
            ))}
          </div>

          <span style={lbl}>Estado inicial</span>
          <div style={{display:"flex",gap:"8px",marginTop:"6px",flexWrap:"wrap"}}>
            {Object.entries(estadosIncidente).slice(0,3).map(([val,{label,color}])=>(
              <button key={val} onClick={() => setForm(f=>({...f,estado:val}))}
                style={{padding:"7px 12px",borderRadius:"10px",fontSize:"12px",cursor:"pointer",fontWeight:"600",border:form.estado===val?`2px solid ${color}`:`1px solid ${borde}`,background:form.estado===val?`${color}22`:cardBg,color:form.estado===val?color:texto}}>
                {label}
              </button>
            ))}
          </div>

          {[
            {key:"fecha",         label:"Fecha del incidente",type:"date"},
            {key:"descripcion",   label:"Descripción del incidente *",multiline:true},
            {key:"sistemaAfectado",label:"Sistema / Equipo afectado"},
            {key:"impacto",       label:"Impacto estimado"},
            {key:"responsable",   label:"Responsable de resolución"},
            {key:"accionesTomadas",label:"Acciones tomadas hasta ahora",multiline:true},
          ].map(({key,label,type,multiline})=>(
            <div key={key}>
              <span style={lbl}>{label}</span>
              {multiline
                ? <textarea rows={3} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} style={{...inp,resize:"none"}}/>
                : <input type={type||"text"} defaultValue={key==="fecha"?fechaHoy():""} onChange={e=>setForm(f=>({...f,[key]:e.target.value}))} style={inp}/>
              }
            </div>
          ))}
        </div>

        <button onClick={guardarIncidente} style={{width:"100%",padding:"15px",background:`linear-gradient(135deg,${Q.azulVivo},${Q.azul})`,color:"white",border:"none",borderRadius:"12px",fontSize:"15px",fontWeight:"700",cursor:"pointer",boxShadow:`0 4px 20px ${Q.azulVivo}40`}}>
          🚨 Registrar Incidente
        </button>
      </div>
    </div>
  );

  // ── NUEVO ACTIVO ──
  if (vista==="nuevo_activo") return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif"}}>
      <Header titulo="🖥 Nuevo Activo Digital" onBack={() => setVista("listado")}/>
      <div style={{padding:"0 2rem 2rem",maxWidth:"700px",margin:"0 auto"}}>
        <div style={card}>
          {[
            {key:"nombre",     label:"Nombre del activo *"},
            {key:"tipo",       label:"Tipo (Computadora, Router, Cuenta, Sistema, etc.)"},
            {key:"propietario",label:"Propietario / Responsable"},
            {key:"criticidad", label:"Criticidad (Alta / Media / Baja)"},
            {key:"ubicacion",  label:"Ubicación / Servidor"},
            {key:"descripcion",label:"Descripción y accesos que tiene",multiline:true},
          ].map(({key,label,type,multiline})=>(
            <div key={key}>
              <span style={lbl}>{label}</span>
              {multiline
                ? <textarea rows={3} onChange={e=>setFormActivo(f=>({...f,[key]:e.target.value}))} style={{...inp,resize:"none"}}/>
                : <input type={type||"text"} onChange={e=>setFormActivo(f=>({...f,[key]:e.target.value}))} style={inp}/>
              }
            </div>
          ))}
        </div>
        <button onClick={guardarActivo} style={{width:"100%",padding:"15px",background:`linear-gradient(135deg,${Q.azulVivo},${Q.azul})`,color:"white",border:"none",borderRadius:"12px",fontSize:"15px",fontWeight:"700",cursor:"pointer",boxShadow:`0 4px 20px ${Q.azulVivo}40`}}>
          💾 Guardar Activo
        </button>
      </div>
    </div>
  );

  // ── LISTADO PRINCIPAL ──
  return (
    <div style={{minHeight:"100vh",background:bg,fontFamily:"sans-serif"}}>
      <div style={{background:navBg,padding:"1rem 1.5rem",display:"flex",alignItems:"center",justifyContent:"space-between",position:"sticky",top:0,zIndex:100,boxShadow:`0 2px 12px ${Q.azul}40`}}>
        <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
          <button onClick={onVolver} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"white",padding:"6px 14px",borderRadius:"10px",cursor:"pointer",fontSize:"13px"}}>← Menú</button>
          <BotonInstructivo moduloKey="ciberseguridad" oscuro={oscuro} />
          {usuario?.rol === "Administrador" && <BotonMapaProceso moduloKey="ciberseguridad" oscuro={oscuro} />}
          <span style={{color:"white",fontWeight:"700",fontSize:"16px"}}>🔐 Ciberseguridad</span>
        </div>
        <div style={{display:"flex",gap:"8px"}}>
          <button onClick={() => setVistaPlanes(v=>!v)}
            style={{padding:"6px 12px",background:vistaPlanes?"rgba(124,58,237,0.3)":"rgba(255,255,255,0.1)",border:`1px solid ${vistaPlanes?"rgba(124,58,237,0.5)":"rgba(255,255,255,0.2)"}`,color:"white",borderRadius:"8px",cursor:"pointer",fontSize:"12px",fontWeight:"600"}}>
            📋 Planes de respuesta
          </button>
        </div>
      </div>

      <div style={{padding:"1.2rem 1.5rem",maxWidth:"840px",margin:"0 auto"}}>

        {/* KPIs */}
        <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))",gap:"10px",marginBottom:"1.5rem"}}>
          {[
            ["Inc. abiertos", resumen.incidentesAbiertos, resumen.incidentesAbiertos===0?"#22c55e":"#e63946", "🔓"],
            ["Críticos/Altos", resumen.incidentesCriticos, resumen.incidentesCriticos===0?"#22c55e":"#7c3aed", "🚨"],
            ["Activos reg.", resumen.totalActivos, Q.azulVivo, "🖥"],
            ["Controles OK", `${resumen.controlesOK}/${resumen.controlesTotal}`, resumen.controlesCriticosPendientes===0?"#22c55e":"#f59e0b", "✅"],
          ].map(([lab,val,col,ico])=>(
            <div key={lab} style={{background:cardBg,borderRadius:"14px",padding:"1rem",border:`1px solid ${borde}`,textAlign:"center",boxShadow:`0 2px 8px ${col}15`}}>
              <p style={{fontSize:"20px",margin:"0 0 6px"}}>{ico}</p>
              <p style={{fontSize:"20px",fontWeight:"800",color:col,margin:"0 0 4px"}}>{val}</p>
              <p style={{fontSize:"10px",color:subtexto,margin:0,fontWeight:"600"}}>{lab}</p>
            </div>
          ))}
        </div>

        {/* PLANES DE RESPUESTA */}
        {vistaPlanes && (
          <div style={{...card,background: oscuro?"#0a0a2e":"#faf5ff",border:`1.5px solid #7c3aed30`,marginBottom:"1.5rem"}}>
            <h3 style={{fontSize:"14px",fontWeight:"800",color:"#7c3aed",marginBottom:"14px",letterSpacing:".05em",textTransform:"uppercase"}}>📋 Planes de respuesta a incidentes</h3>
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:"10px"}}>
              {PLANES_RESPUESTA.map(p=>(
                <button key={p.id} onClick={() => setPlanActivo(p)}
                  style={{background:`${p.color}10`,border:`1.5px solid ${p.color}30`,borderRadius:"12px",padding:"1rem",cursor:"pointer",textAlign:"left",transition:"box-shadow 0.15s"}}
                  onMouseEnter={e=>e.currentTarget.style.boxShadow=`0 4px 16px ${p.color}30`}
                  onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
                  <p style={{fontSize:"24px",margin:"0 0 8px"}}>{p.icono}</p>
                  <p style={{fontSize:"13px",fontWeight:"700",color:p.color,margin:"0 0 4px"}}>{p.titulo}</p>
                  <p style={{fontSize:"11px",color:subtexto,margin:0}}>{p.pasos.length} pasos de respuesta</p>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* TABS */}
        <div style={{display:"flex",gap:"6px",marginBottom:"1.2rem",background:cardBg,borderRadius:"12px",padding:"6px",border:`1px solid ${borde}`}}>
          {[["incidentes","🚨 Incidentes"],["activos","🖥 Activos"],["controles","✅ Controles"]].map(([id,label])=>(
            <button key={id} onClick={() => setTab(id)}
              style={{flex:1,padding:"8px",borderRadius:"8px",border:"none",cursor:"pointer",fontSize:"12px",fontWeight:"700",background:tab===id?`linear-gradient(135deg,${Q.azulVivo},${Q.azul})`:"transparent",color:tab===id?"white":subtexto,transition:"all 0.2s"}}>
              {label}
            </button>
          ))}
        </div>

        {/* TAB: INCIDENTES */}
        {tab==="incidentes" && (
          <div>
            <div style={{display:"flex",justifyContent:"flex-end",marginBottom:"1rem"}}>
              {esAdmin && (
                <button onClick={() => setVista("nuevo_incidente")}
                  style={{padding:"7px 16px",background:"#e63946",color:"white",border:"none",borderRadius:"10px",cursor:"pointer",fontSize:"13px",fontWeight:"600",boxShadow:"0 4px 12px rgba(230,57,70,0.3)"}}>
                  🚨 Nuevo incidente
                </button>
              )}
            </div>
            {incidentes.length===0
              ? <div style={{textAlign:"center",padding:"4rem"}}>
                  <p style={{fontSize:"40px"}}>🛡️</p>
                  <p style={{fontSize:"15px",color:texto,fontWeight:"600",marginTop:"1rem"}}>Sin incidentes registrados</p>
                  <p style={{fontSize:"13px",color:subtexto}}>¡Eso es una buena señal! Registrá cualquier evento de seguridad apenas ocurra.</p>
                </div>
              : [...incidentes].reverse().map(inc=>(
                  <div key={inc.id} onClick={() => {setDetalle(inc); setVista("detalle");}}
                    style={{background:cardBg,borderRadius:"14px",padding:"1.2rem 1.5rem",border:`1.5px solid ${severidades[inc.severidad]?.color}40`,marginBottom:"10px",cursor:"pointer",transition:"box-shadow 0.15s",borderLeft:`4px solid ${severidades[inc.severidad]?.color}`}}
                    onMouseEnter={e=>e.currentTarget.style.boxShadow=`0 4px 20px ${severidades[inc.severidad]?.color}25`}
                    onMouseLeave={e=>e.currentTarget.style.boxShadow="none"}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                      <div style={{flex:1}}>
                        <div style={{display:"flex",alignItems:"center",gap:"8px",flexWrap:"wrap"}}>
                          <span style={{fontWeight:"700",color:Q.azulVivo,fontSize:"12px"}}>{inc.codigo}</span>
                          <span style={{fontSize:"13px",color:texto,fontWeight:"600"}}>{inc.tipo}</span>
                          <span style={{fontSize:"10px",fontWeight:"700",color:severidades[inc.severidad]?.color,background:`${severidades[inc.severidad]?.color}15`,padding:"1px 8px",borderRadius:"6px"}}>{severidades[inc.severidad]?.label}</span>
                        </div>
                        <p style={{fontSize:"12px",color:subtexto,margin:"4px 0 0",lineHeight:"1.4"}}>{inc.descripcion?.slice(0,80)}{inc.descripcion?.length>80?"...":""}</p>
                      </div>
                      <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:"4px",flexShrink:0}}>
                        <span style={{fontSize:"11px",fontWeight:"700",color:estadosIncidente[inc.estado]?.color}}>{estadosIncidente[inc.estado]?.label}</span>
                        <span style={{fontSize:"11px",color:subtexto}}>{inc.fecha}</span>
                      </div>
                    </div>
                  </div>
                ))
            }
          </div>
        )}

        {/* TAB: ACTIVOS */}
        {tab==="activos" && (
          <div>
            <div style={{display:"flex",justifyContent:"flex-end",marginBottom:"1rem"}}>
              {esAdmin && (
                <button onClick={() => setVista("nuevo_activo")}
                  style={{padding:"7px 16px",background:Q.azulVivo,color:"white",border:"none",borderRadius:"10px",cursor:"pointer",fontSize:"13px",fontWeight:"600",boxShadow:`0 4px 12px ${Q.azulVivo}40`}}>
                  + Nuevo activo
                </button>
              )}
            </div>
            {activos.length===0
              ? <div style={{textAlign:"center",padding:"4rem"}}>
                  <p style={{fontSize:"40px"}}>🖥</p>
                  <p style={{fontSize:"15px",color:texto,fontWeight:"600",marginTop:"1rem"}}>Sin activos registrados</p>
                  <p style={{fontSize:"13px",color:subtexto}}>Registrá todos los dispositivos, sistemas y accesos de la empresa para tener visibilidad completa.</p>
                </div>
              : activos.map(a=>(
                  <div key={a.id} style={{background:cardBg,borderRadius:"14px",padding:"1.2rem 1.5rem",border:`1px solid ${borde}`,marginBottom:"10px"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start"}}>
                      <div>
                        <span style={{fontSize:"14px",fontWeight:"700",color:texto}}>{a.nombre}</span>
                        {a.tipo && <span style={{marginLeft:"8px",fontSize:"11px",color:subtexto,background: oscuro?"#091840":Q.grisPalido,padding:"2px 8px",borderRadius:"6px"}}>{a.tipo}</span>}
                        <p style={{fontSize:"12px",color:subtexto,margin:"4px 0 0"}}>Propietario: {a.propietario||"—"} · Criticidad: {a.criticidad||"—"}</p>
                      </div>
                      <span style={{fontSize:"11px",color:subtexto}}>{new Date(a.fechaCreacion).toLocaleDateString('es-AR')}</span>
                    </div>
                    {a.descripcion && <p style={{fontSize:"12px",color:subtexto,margin:"6px 0 0",lineHeight:"1.5"}}>{a.descripcion}</p>}
                  </div>
                ))
            }
          </div>
        )}

        {/* TAB: CONTROLES */}
        {tab==="controles" && (
          <div>
            <div style={{...card,background: oscuro?"#0a1f3c":"#eff6ff",border:`1px solid ${Q.azulVivo}30`,marginBottom:"1rem"}}>
              <p style={{fontSize:"13px",fontWeight:"700",color:Q.azul,margin:"0 0 6px"}}>
                📊 Estado general: {resumen.controlesOK}/{resumen.controlesTotal} controles completados
                {resumen.controlesCriticosPendientes>0 && <span style={{marginLeft:"8px",fontSize:"11px",color:"#e63946",fontWeight:"700"}}> · {resumen.controlesCriticosPendientes} críticos pendientes</span>}
              </p>
              <div style={{background: oscuro?"#0a1f5c":Q.grisClaro,borderRadius:"8px",height:"8px",overflow:"hidden"}}>
                <div style={{height:"100%",width:`${(resumen.controlesOK/resumen.controlesTotal)*100}%`,background:`linear-gradient(90deg,${Q.azulVivo},#22c55e)`,borderRadius:"8px",transition:"width 0.5s"}}/>
              </div>
            </div>

            {controles.map(c=>(
              <div key={c.id} style={{background:c.completado?(oscuro?"#0a1f0a":"#f0fdf4"):cardBg,borderRadius:"12px",padding:"1rem 1.5rem",border:`1px solid ${c.completado?"#22c55e30":c.critico?"#e6394640":borde}`,marginBottom:"8px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:"6px"}}>
                    {c.critico && <span style={{fontSize:"9px",fontWeight:"800",background:"#e63946",color:"white",padding:"1px 6px",borderRadius:"4px"}}>CRÍTICO</span>}
                    <span style={{fontSize:"13px",color:texto,fontWeight:"600"}}>{c.label}</span>
                  </div>
                  <p style={{fontSize:"11px",color:subtexto,margin:"3px 0 0"}}>
                    Frecuencia: {c.frecuencia}
                    {c.ultimaRevision && ` · Revisado: ${new Date(c.ultimaRevision).toLocaleDateString('es-AR')} por ${c.revisadoPor}`}
                  </p>
                </div>
                {c.completado
                  ? <span style={{fontSize:"20px"}}>✅</span>
                  : esAdmin && (
                      <button onClick={() => completarControl(c.id)}
                        style={{padding:"6px 14px",background:`linear-gradient(135deg,${Q.azulVivo},${Q.azul})`,color:"white",border:"none",borderRadius:"8px",cursor:"pointer",fontSize:"12px",fontWeight:"600",flexShrink:0}}>
                        Marcar OK
                      </button>
                    )
                }
              </div>
            ))}
            <p style={{fontSize:"11px",color:subtexto,textAlign:"center",marginTop:"8px"}}>Los controles se reinician automáticamente según su frecuencia para mantener el ciclo de revisión activo.</p>
          </div>
        )}
      </div>
    </div>
  );
}